<template>
  <div>
    <v-data-table :loading="loading" :headers="headers" :items="EMPLOYEES.data" class="elevation-1" hide-default-footer>
      <template v-slot:[`item.is_active`]="{ item }">
        <v-icon v-if="item.is_active == 1" color="success">
          mdi-check-circle
        </v-icon>
        <v-icon v-else color="error"> mdi-close-circle </v-icon>
      </template>
      <template v-slot:[`item.image`]="{ item }">
        <v-avatar size="40">
          <img :src="item.image" />
        </v-avatar>
      </template>
      <template v-slot:no-data> No data </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon color="warning" class="mr-2" @click.stop="edit(item)">
          mdi-pencil-box-outline
        </v-icon>
      </template>

      <template v-slot:top>
        <v-row dense class="mx-2">
          <base-column :lg="4" :md="4" :sm="12">
            <v-text-field v-model="search.search" append-icon="mdi-magnify" label="Search" outlined dense
              hide-details></v-text-field>
          </base-column>
          <base-column :lg="4" :md="4" :sm="12" v-if="(ROLE == 'Owner')">
            <v-select v-model="search.branch_id" :items="branch" item-text="name" item-value="id" label="Branch" outlined dense
              hide-details></v-select>
          </base-column>
          <base-column :lg="3" :md="4" :sm="12">
            <v-btn small color="darkblue" class="white--text" @click.stop="searching">Submit <v-icon
                right>mdi-magnify</v-icon></v-btn>
            <v-btn small color="secondary" class="white--text mx-1" @click.stop="clear">Clear
              <v-icon right>mdi-close-circle-multiple </v-icon>
            </v-btn>
          </base-column>
        </v-row>
      </template>
    </v-data-table>

    <v-pagination v-model="currentPage" :length="lastPage" :total-visible="10" :disabled="disabled"></v-pagination>
  </div>
</template>

<script>
import BaseColumn from "@/components/base/BaseColumn";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "CustomerList",
  data() {
    return {
      headers: [
        { text: "Name", value: "name" },
        { text: "Branch", value: "branch.name" },
        { text: "Phone", value: "phone" },
        { text: "Email", value: "email" },
        { text: "Address", value: "address" },
        { text: "Image", value: "image" },
        { text: "Status", value: "is_active" },
        { text: "Action", value: "actions", sortable: false, width: 100 },
      ],
      page: 1,
      disabled: false,
      loading: false,
      status: ["Active", "Inactive"],
      branch: [],
      search: {
        search: null,
        branch_id: null,
      },
    };
  },

  created() {
    this.getBranch();
    this.getEmployee();
  },
  methods: {
    ...mapMutations("employee", ["SET_EMPLOYEES", "CLEAR_STATE"]),
    async getEmployee() {
      this.loading = true;
      this.disabled = true;
      let params = {
        page: this.page,
        search: this.search.search,
        branch_id: this.search.branch_id,
      };

      await this.$axios
        .get("/master/employees", {
          params: params,
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.SET_EMPLOYEES(data.employees);
          this.loading = false;
          this.disabled = false;
        });
    },

    async getBranch() {
      await this.$axios
        .get("/master/branches", {
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.branch = data.branch.data;
        });
    },
    searching() {
      this.page = 1;
      this.getEmployee();
    },
    clear() {
      this.page = 1;
      this.search = {
        search: "",
        branch_id: null,
      };
      this.getEmployee();
    },

    edit(item) {
      this.$router.push("/master/employee/edit/" + item.id);
    },
  },
  watch: {
    currentPage(newValue) {
      this.page = newValue;
      this.getEmployee();
    },
  },
  computed: {
    ...mapGetters("employee", {
      EMPLOYEES: "Employees",
    }),

    ...mapGetters("auth", {
      ROLE: "Role",
    }),

    currentPage: {
      get() {
        return this.EMPLOYEES.current_page;
      },
      set(val) {
        return this.$store.commit("employee/SET_CURRENT_PAGE", val);
      },
    },
    lastPage: {
      get() {
        return this.EMPLOYEES.last_page;
      },
    },
  },

  components: {
    BaseColumn,
  },
};
</script>
